import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//
import { Button } from "react-bootstrap";

//
import ImageBox from "../../components/general/ImageBox";

//
import Stripe from "../../assets/img/stripe-logo.webp";
import BoxLoading from "../../components/general/BoxLoading";

//
import { cancelStripePayment } from "../../redux/features/plan/actions";

function Cancel() {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Get query from url
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();

  let id = query.get("session_id");

  const cancel_payment = async () => {
    if (id) {
      // start loading
      setLoading(true);

      // request
      await cancelStripePayment({id});

      // stop loading
      setLoading(false);
    }
  };

  useEffect(() => {
    cancel_payment();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {loading && <BoxLoading />}

      <ImageBox src={Stripe} />
      <h4>Payment Canceled</h4>
      <p>
        Your payment has been canceled. Contact support if you have any problems
      </p>
      <Button
        size="lg"
        variant="info"
        className="w-100"
        onClick={() => navigate("/app/account")}
      >
        Back
      </Button>
    </div>
  );
}

export default Cancel;
